import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { MaterialModule } from '../material.module';
import { ExtraComponentModule } from './components/extra.component.module';
import { AuthAPIService } from './services/auth-api.service';
import { CanDeactivateGuard } from './can-deactivate/can-deactivate.guard';
import { TranslocoModule } from '@ngneat/transloco';
import { DetailsModule } from './views/details/details.module';
import { TicketsModule } from './views/tickets/tickets.module';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      /* tickets and details not lazy loaded, causing problem when navigating from fb login
       */
      {
        path: 'tickets',
        loadChildren: () => TicketsModule,
      },
      {
        path: 'details',
        loadChildren: () => DetailsModule,
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'payment',
        loadChildren: () => import('./views/payment/payment.module').then((m) => m.PaymentModule),
      },
      {
        path: 'payment-bank',
        loadChildren: () => import('./views/payment-bank/payment-bank.module').then((m) => m.PaymentBankModule),
      },
      {
        path: 'expired',
        loadChildren: () => import('./views/expired/expired.module').then((m) => m.ExpiredModule),
      },
      {
        path: 'upcoming',
        loadChildren: () => import('./views/upcoming/upcoming.module').then((m) => m.UpcomingModule),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'tickets',
      },
    ],
  },
  {
    path: 'summary',
    loadChildren: () => import('./views/summary/summary.module').then((m) => m.SummaryModule),
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  declarations: [HomeComponent],
  imports: [CommonModule, RouterModule.forChild(routes), MaterialModule, TranslocoModule, ExtraComponentModule],
  providers: [AuthAPIService, CanDeactivateGuard],
  exports: [RouterModule, TranslocoModule],
})
export class HomeRoutingModule {}
